import { Injectable } from '@angular/core';

export const TENANT_STORAGE_DELIMITER = '::';

@Injectable({
    providedIn: 'root',
})
export class TenantAwareStorageService {
    constructor() {}

    public getItem(key: string): string | null {
        const scopedKey = this.buildScopedKey(key);
        if (scopedKey !== key) {
            const scopedValue = localStorage.getItem(scopedKey);
            if (scopedValue !== null) {
                return scopedValue;
            }
        }
        return localStorage.getItem(key);
    }

    public setItem(key: string, value: string): void {
        const scopedKey = this.buildScopedKey(key);
        localStorage.setItem(scopedKey, value);
    }

    private buildScopedKey(key: string): string {
        const customerId = this.getCustomerId();
        if (!customerId || key.includes(TENANT_STORAGE_DELIMITER)) {
            return key;
        }
        return `${key}${TENANT_STORAGE_DELIMITER}${customerId}`;
    }

    private getCustomerId(): string | null {
        const configItem = localStorage.getItem('userConfig');
        if (!configItem) {
            return null;
        }
        try {
            const config = JSON.parse(configItem);
            return config?.customerId ?? null;
        } catch (error) {
            console.warn('Unable to parse userConfig for customer id', error);
            return null;
        }
    }
}
